<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
<div>
  <div class="caption pink--text text--lighten-3 mb-2" style="font-weight: 300;">
     <v-icon size="18" class="mr-1" color="yellow darken-2">warning</v-icon>
     Important Note: Tests per province are from the NICD Weekly Epidemiology Brief</div>
  <apexchart type="bar" height="310" :options="chartOptions" :series="series" />
</div>  
</template>

<script>
export default {
  name: "TestsProvs",
  data: () => ({
    series: [
      {
        name: "series1",
        data: []
      }
    ],
    chartOptions: {
      theme: {
        mode: "dark",
        palette: "palette10"
      },
      colors: ["#e91e63", "#A300D6", "#008FFB", "#F86624", "#d6c51b", "#61c1a1", "#53aeb6", "#da80b1", "#28b4c9"],
      chart: {
        background: "rgb(28, 42, 82)",
        foreColor: "rgb(212, 212, 212)",
        toolbar: {
          show: true,
          tools: {
            download: false,
            selection: false
          },
          autoSelected: "zoom"
        }
      },
      grid: {
        borderColor: "rgb(27, 36, 77)"
      },
      title: {
        text: "Total Tests",
        offsetY: 10,
        align: 'center',
        style: {
          fontSize: "16px",
          fontWeight: 600
        }
      },
      legend: {
        show: false,
        position: "bottom",
        itemMargin: {
          vertical: 10
        }
      },
      markers: {
        size: 2
      },
      plotOptions: {
        bar: {
          columnWidth: "50%",
          distributed: true
        }
      },
      xaxis: {
        categories: [],
        labels: {
          style: {
            fontSize: "10px"
          }
        }
      }
    }
  }),
  methods: {
    loadCases(data, provinceDisplay) {
      this.series[0].data = [];

      var provCounts = {};

      var provs = [];
      //first get all the distinct provinces
      provs = Array.from(new Set(data.map(cas => cas.region))).map(province => {
        return province;
      });

      for (var i = 0; i < provs.length; i++) {
        if(provs[i] !== "National") {
          provCounts[provs[i]] = 0
        }
      }

      //filter out only entries with prov tests
      var filteredData = data.filter(c => c.tests !== "" && c.region !== "National")

      //find the last 100k pax test count per prov
      var provsData = []
      var lastDate = ""
      for (var key in provCounts) {

        //loop backwards
        for (var i = filteredData.length - 1; i >= 0; i--) {
          if(filteredData[i].region === key) {
            provsData.push({province: key, countpax: filteredData[i].tests_100kpax*1, count: filteredData[i].tests*1})
            lastDate = filteredData[i].date
            break
          }
        }
      }

      //assign the fixed colors
      //first sort by name
      provsData = provsData.sort(function(a, b) {
        a = a.province;
        b = b.province;
        return a < b ? -1 : a > b ? 1 : 0;
      });

      var colors = ["#008FFB","#d6c51b","#A300D6","#F86624","#da80b1","#61c1a1","#53aeb6","#28b4c9", "#545454","#e91e63"]

      //assign the new color
      for (var i = 0; i < provsData.length; i++) {  
       provsData[i].color = colors[i]
      }

      //sort by count desc
      provsData = provsData.sort(function(a, b) {
        a = a.count;
        b = b.count;
        return a > b ? -1 : a < b ? 1 : 0;
      });

      //get the new colors order
      var newColors = []
      for (var i = 0; i < provsData.length; i++) {  
        newColors.push(provsData[i].color)
      }
      
      //loop and extract cols and vals
      var cols = [];
      var vals = [];

      for (var i = 0; i < provsData.length; i++) {
        cols.push(provsData[i].province);
        vals.push(provsData[i].count);
      }

      //set the graph data
      this.series = [{ name: "Total Tests as at " + lastDate, data: vals }];
      this.chartOptions = {
        colors: newColors,
        xaxis: {
          categories: cols
        },
        title: {
          text: "Total Tests as at " + lastDate
        }
      };

      // //get the population details
      // fetch('data/geo/sa_provinces.json')
      //   .then(response => {
      //     return response.json()
      //   })
      //   .then(popdata => {
      //     //get each prov
      //     for (var i = 0; i < popdata.features.length; i++) {
      //       var feat = popdata.features[i]

      //       //calc pop
      //       var popCount = feat.properties.populationEstimate*1
            
      //       //find prov 
      //       var match = provsData.find(c => c.province === feat.properties.province)
      //       if(match) {
      //         var estCount = (match.countpax/100000) * popCount
      //         match.count = parseFloat(estCount.toFixed(0))
      //       }
            
      //     } 
          
      //     //sort by count desc
      //     provsData = provsData.sort(function(a, b) {
      //       a = a.count;
      //       b = b.count;
      //       return a > b ? -1 : a < b ? 1 : 0;
      //     });

      //     //loop and extract cols and vals
      //     var cols = [];
      //     var vals = [];

      //     for (var i = 0; i < provsData.length; i++) {
      //       cols.push(provsData[i].province);
      //       vals.push(provsData[i].count);
      //     }

      //     //set the graph data
      //     this.series = [{ name: "Total Tests as at " + lastDate, data: vals }];
      //     this.chartOptions = {
      //       xaxis: {
      //         categories: cols
      //       },
      //       title: {
      //         text: "Total Tests as at " + lastDate
      //       }
      //     };

      //   })
      //   .catch(err => {
      //     console.error(err)
      // })
    },
    resize() {
      let self = this;
      this.$nextTick().then(function() {
        self.chartOptions = {
          chart: {
            height: "310"
          }
        };
      });
    }
  }
};
</script>
